import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken } from "@/util/cookie.js";
import store from "@/store";
import router from "@/router";
import local from "./util/local";

NProgress.configure({ showSpinner: false });

const whiteListRouters = store.getters["permission/whiteListRouters"];
router.beforeEach(async (to, from, next) => {
  console.log(from, to)
  const canAccess = checkRouter(to)
  if (!canAccess) {
    if (checkRouter(from)) {
      // 返回上一级
      NProgress.start()
      next(from.path);
      NProgress.done()
    } else {
      // 但如果因为重定向导致上一级也无法访问
      // 就找一个可访问的路由去跳转
      await firstAvailableRoute((path)=>{
        NProgress.start()
        next(path);
        NProgress.done()
      }, ()=>{
        // 如果没有可访问的路由
        // 不跳转，并提示
        alert('您还没有分配任何权限')
      })
    }
    return
  }

  NProgress.start();
  const token = getToken();
  // const token=true
  // console.log(token);
  if (token) {
    if (to.path === "/login") {
      // setTimeout(() => {
      //   store.dispatch("permission/restore");
      // });
      next();
      return;
    }

    try {
      await store.dispatch("permission/initRoutes");
      next();
    } catch (error) {
      // console.log(err)
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  } else {
    // console.log(whiteListRouters);
    /* white list router */
    if (whiteListRouters.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login?redirect=${to.path}`);
    }
    NProgress.done();
  }
});

router.afterEach(() => {
  NProgress.done();
});

function checkRouter(to) {
  const toPath = to.path
  const staffMenuList = local.getStaffMenuList()
  let canAccess = false;
  if (toPath == '/login' || toPath == '/') {
    // 总是允许访问登录页
    canAccess = true
  } else {
    const target = staffMenuList.some((p) => {
      return p.url && decodeURIComponent(toPath).startsWith(p.url)
    })
    if (target) {
      canAccess = true
    }
  }
  return canAccess
}

export async function firstAvailableRoute(success, fail) {
  const staffMenuList = local.getStaffMenuList() || []
  if (staffMenuList.length == 0) {
    fail()
    return
  }
  // 找到第一个有 url 的菜单项（可能是二级菜单）
  const firstWithUrl = staffMenuList.find(item => item.url)
  if (firstWithUrl) {
    success(firstWithUrl.url)
  } else {
    fail()
  }
}




// WEBPACK FOOTER //
// ./src/permission.js